<template>
  <div v-if="driverDetails" class="driver-assign-outer-blk">
    <div class="driver-content-blk">
      <div class="driver-name-blk">
        <span class="driver-header-blk">Driver : </span>
        <span class="driver-blk">{{ driverDetails.name }}</span>
      </div>

      <div class="update-block">
        <!-- <v-btn small color="#659af3" @click="openUpdateDialog">Update Pickup date</v-btn> -->
      </div>
    </div>

    <div class="vehicle-modal">
      <div class="trip-assign-block">
        <span><i class="fas fa-exclamation-triangle"></i>This Driver is assigned to this trips - </span>
        <span v-for="data in driverDetails.tripList" :key="data.id" class="margin-left">{{ data.tripid }}</span>
      </div>

      <div class="driver-alert-blk" v-if="driverDetails.tripList.length > 0"></div>
      <!-- <div class="vehicle-add-modal">
        <div class="text-field-blk">
          <v-text-field
              v-model="vehicleNo"
              placeholder="Vehicle No"
              label="Vehicle No"
              dense
              outlined
              hide-details
              @keydown.space.prevent
          >
          </v-text-field>
          <v-autocomplete
              v-model="model"
              placeholder="Model"
              label="Model"
              :items="modelList"
              return-object
              item-text="name"
              dense
              outlined
              clearable
              hide-details
          >

          </v-autocomplete>
        </div>
        <div class="add-assign-button-blk">
          <v-btn color="#eea004" :disabled="vehicleNo === '' || model === ''" @click="addAndAssign">Add & Assign</v-btn>
        </div>
      </div> -->

<div style="display: flex;flex-wrap: wrap; justify-content: center;">
      <div class="vehicle-content-blk" v-for="(data, index) in driverDetails.vehicle" :key="index"
        :class="{ 'selected-vehicle-blk': data.id === vehicleData.id, 'ongoing-vehicle-blk': data.tripId }" :style="{ 
        opacity: data.trash === 1 ? 0.5 : 100,
        cursor: data.trash === 1 ? 'not-allowed' : 'pointer',
  position: data.trash === 1 ? 'relative' : ''
      
    }" @click="data.trash !== 1 && selectVehicle(data)">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <span v-if="data.trash === 1" v-bind="attrs" v-on="on"
              style="position: absolute; top: 10px; right: 20px; cursor: pointer;">
              <svg style="height: 20px; width: 20px;" viewBox="0 -0.5 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M13.7744 1.41218L23.4802 20.0771C23.9898 21.0571 23.6085 22.2646 22.6285 22.7742C22.3435 22.9224 22.027 22.9998 21.7058 22.9998H2.29425C1.18968 22.9998 0.29425 22.1044 0.29425 20.9998C0.29425 20.6786 0.371621 20.3621 0.519817 20.0771L10.2256 1.41218C10.7352 0.432187 11.9427 0.0508554 12.9227 0.560452C13.2874 0.75009 13.5848 1.04749 13.7744 1.41218ZM2.29425 20.9998H21.7058L12 2.33489L2.29425 20.9998ZM12 16.9998C12.5523 16.9998 13 17.4475 13 17.9998C13 18.5521 12.5523 18.9998 12 18.9998C11.4477 18.9998 11 18.5521 11 17.9998C11 17.4475 11.4477 16.9998 12 16.9998ZM13 14.9998C13 15.5521 12.5523 15.9998 12 15.9998C11.4477 15.9998 11 15.5521 11 14.9998V9.99981C11 9.44752 11.4477 8.99981 12 8.99981C12.5523 8.99981 13 9.44752 13 9.99981V14.9998Z"
                  fill="#db000b" />
              </svg>
            </span>
          </template>
          <span>Vehicle Inactive</span>
        </v-tooltip>


        <!-- <b v-if="data.trash===1" style="color: red;">Vehicle  Inactive</b> -->
        <span class="vehicle-number-blk">{{ data.vehicleNo }}</span>
        <span>{{ data.model.name }}</span>
        <span>{{ data.category }}</span>
        <span class="ongoing-trip-blk" v-if="data.tripId">Vehicle is already on trip - {{ data.tripId }}</span>
      </div>
</div>

    </div>
    <div class="assign-button-blk">
      <v-btn color="#bbb6b6" @click="closeDialog">Close</v-btn>
      <v-btn color="#eea004" @click="openUpdateDialog" :disabled="vehicleData === ''">Assign & Accept</v-btn>
    </div>
    <!-- assignDriver(true) -->

    <Loading v-if="loading"></Loading>
    <Confirm ref="confirm"></Confirm>

    <v-dialog width="500" v-model="dialogView">
      <v-card class="card-modal-view">
        <span>Vehicle belongs to another vendor,please contact taSki to assign this vehicle</span>
        <div class="card-button-blk">
          <v-btn small color="#eea004" @click="closeDVehicleDialog">OK</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <v-dialog width="700" v-model="dialog" persistent>
      <PickUpTimeUpdate :tripDetails="tripDetails" @submit="submitTrip" @cancelSubmit="cancelSubmit"
        :driverDetails="driverDetails" :vehicleData="vehicleData" :timeStampDetails="timeStampDetails" @club-trip="clubTrip"></PickUpTimeUpdate>
    </v-dialog>

    <v-dialog width="1100" v-model="clubbingDialog" persistent>
      <TripClubbing :disableBtn="disableButton" @unassign="handleUnassign" :changedTime="changedPickUpDate" :tripList="tripList"
        @check-select="clubTrip" @close-clubbing="closeClubbing" :tripDetails="tripDetails"></TripClubbing>
    </v-dialog>
  </div>
</template>

<script>
import axios from "@/axios/axios-global";
import Loading from "@/components/common/Loading";
import Confirm from "@/components/common/Confirm";
import PickUpTimeUpdate from "../PickUpTimeUpdate.vue";
import TripClubbing from "./../to-be-assigned/TripClubbing.vue";
import moment from "moment-timezone";

export default {
 name: "DriverAssign",
 components: { Confirm, Loading, PickUpTimeUpdate, TripClubbing },
 props: {
  driverDetails: Object,
  bigId: Number,
  driverNumber: String,
  modelList: Array,
  currentState: Number,
  currentCity: Number,
  tripDetails: Object,
 },
  watch: {


    
  vehicleNo() {
   this.vehicleNo = this.vehicleNo.toUpperCase();
  },
  model() {
   if (this.model === null) {
    this.model = "";
   }
  },
  },

  mounted() {
  this.checkAutoSelectVehicle()
  this.tripDetails.employees.forEach((employee) => {
   if (employee.dateMenu === undefined) {
    this.$set(employee, "dateMenu", false);
   }
   //  employee["selectedDate"] = moment(employee.pickupdate, "DD-MM-YYYY hh:mm A").format("DD-MM-YYYY");
   //  employee["selectedTime"] = moment(employee.pickupdate, "DD-MM-YYYY hh:mm A").format("HH:mm");
  });
  // if (this.driverDetails.vehicle && this.driverDetails.vehicle.length === 1) {
  //  this.vehicleData = this.driverDetails.vehicle[0];
  //  }


   
 },

 data: () => {
  return {
   vehicleData: "",

   vehicleNo: "",
   model: "",

   filterData: "",

   loading: false,

   dialogView: false,

   dialog: false,

   employees: [],

   tripList: [],
    crewIds: [],
disableButton:false,
   clubbingDialog: false,
   changedPickUpDate: "",
   timeStampDetails: {
    time: null,
    timeZone: "Asia/Kolkata",
   },
  };
 },

 // async mounted() {
 //   await this.getFilters()
 // },
  methods: {

    handleUnassign(data)
    {
  this.$emit('unassign',data)
},

checkAutoSelectVehicle() {
  const vehicles = this.driverDetails.vehicle;
  if (!vehicles || vehicles.length === 0) return;

  const activeVehicles = vehicles.filter(vehicle => vehicle.trash !== 1);

  if (activeVehicles.length === 1 ) {
    console.log('Auto-selecting single active vehicle:', activeVehicles[0]);
    this.selectVehicle(activeVehicles[0]);
  }
},


  openUpdateDialog() {
   // && this.tripDetails.etsDetails.serviceType === "PickUp"
   if (["IndiGo", "Test Indigo"].includes(this.tripDetails.corporate) && this.tripDetails.employees.length > 0) this.dialog = true;
   else this.assignDriver(true);
  },
    submitTrip(data) {
      this.employees = data.employees;
      this.changedPickUpDate = data.pickUpdate;
    this.crewIds=data.crewIds;
      this.assignDriver(true);
    },
    cancelSubmit() {
      this.dialog = false;
    },
    selectVehicle(data) {
      this.vehicleData = data;
    },

    // async getFilters() {
    //   const response = await axios.post('/router/modelList', {tripId: this.bigId})
    //   this.filterData = response.data
    // },
    // async addAndAssign() {
    //   let confirmTitle = "Confirm Add & Assign";
    //   let confirmText = "Please confirm to Add and Assign the vehicle";
    //   if (await this.$refs.confirm.open(confirmTitle, confirmText)) {
    //     this.loading = true
    //     try {
    //       const payload = {
    //         driver: {
    //           name: this.driverDetails.name,
    //           number: this.driverNumber,
    //           city: this.currentCity,
    //           state: this.currentState
    //         },
    //         cab: {
    //           vehicleNo: this.vehicleNo,
    //           model: this.model,
    //           color: {id: 1, name: "White"},
    //           fuel: {id: 1, name: "Diesel"},
    //           year: 2018
    //         },
    //         tripId: this.bigId,
    //         driverConfirm: true,
    //       }
    //       const response = await axios.post('/trip/assign', payload)
    //       if (response.status === 200) {
    //         this.loading = false
    //         this.$toasted.show(response.data.message, {
    //           position: "bottom-center",
    //           duration: 4000
    //         });
    //         const emitDetails = {
    //           name: this.driverDetails.name,
    //           number: this.driverNumber,
    //           vehicleNo: this.vehicleNo
    //         }
    //         this.$emit('assign-driver', emitDetails)
    //       } else if (response.status === 206) {
    //         this.loading = false
    //         this.dialogView = true
    //         // this.$toasted.show(response.data, {
    //         //   position: "bottom-center",
    //         //   duration: 5000
    //         // });
    //       }
    //     } catch (error) {
    //       this.loading = false
    //       // this.$toasted.show(error.response.data, {
    //       //   position: "bottom-center",
    //       //   duration: 4000
    //       // });
    //     }
    //   }
    // },

    async clubTrip(data) {
      this.loading = true;
      this.disableButton=true
      try {
        const clubFrom = data.filter((trip) => trip);
        const payload = {
          clubFrom: clubFrom,
          clubTo: this.bigId,
        };
        const response = await axios.post("/trip/clubbing", payload);
        if (response.status === 200) {
          this.loading = false;
          this.$toasted.show(response.data.message, {
            position: "bottom-center",
            duration: 4000,
          });

          const emitDetails = {
            name: this.driverDetails.name,
            number: this.driverNumber,
            vehicleNo: this.vehicleData.vehicleNo,
          };
          this.$emit("assign-driver", emitDetails);
          this.disableButton=false
        } else {
          this.loading = false;
       
          this.$toasted.show(response.data.message, {
            position: "bottom-center",
            duration: 4000,
          });
                 this.disableButton=false
        }
      } catch (error) {
        this.loading = false;
            this.disableButton=false
        console.log(error, "error");
      }
    },
    async getDriverDetails(data, index) {
      if (data && data.driver && data.driver.length === 10) {
        this.drivers = [...this.defaultDrivers];
        this.tripId = data.bigId;
        this.tripIndex = index;
        this.bigId = data.bigId;
        this.tripDetails = data;
        this.loading = true;
        const response = await axios.post("trip/driver/details", { mobile: data.driver, tripId: data.bigId });
        console.log(response);
        this.loading = false;

        if (response.data.driverDetails) {
          if (response.data.driverDetails.trash) {
            this.message = "This driver is Inactive";
            return (this.dialogView = true);
          }
          this.driverNumber = data.driver;
          if (response.data.message !== "No driver exist in this number" && response.data.message !== "No vehicle assigned") {
            this.assignDialog = true;
            this.driverDetails = response.data.driverDetails;
            this.currentCity = response.data.currentCity;
            this.currentState = response.data.currentState;
            if (response.data.timeStampDetails) {
              this.timeStampDetails = response.data.timeStampDetails;
            }
          } else {
            this.dialogView = true;
            this.driverNumber = data.driver;
            this.message = response.data.message;
          }
        } else if (response.data.message === "No driver exist in this number") {
          this.dialogView = true;
          this.driverNumber = data.driver;
          this.message = response.data.message;
        } else if (response.data.message === "Driver exists for another servicePartner") {
          this.dialogView = true;
          this.driverNumber = data.driver;
          this.message = "Driver exists for another vendor, please contact taSki to assign the trip to this driver";
        } else if (response.data.message === "Driver exists for another Branch") {
          this.dialogView = true;
          this.driverNumber = data.driver;
          this.message = "Driver exists for another Branch";
        }
      }
    },
    showDetails(data) {
      this.drawer = true;
      this.tripId = data;
    },
    driverAssign(data) {
      this.assignDialog = false;
      this.drivers = [...this.defaultDrivers];
      this.getTripData(this.filters);
    },
    submitUnclub() {
      this.unclubDialog = false;
      this.getTripData(this.filters);
    },
    driverCabAssign(data) {
      this.tripList[this.tripIndex].driverDetails = { name: data.name, mobile: data.number };
      this.tripList[this.tripIndex].vehicle = data.vehicleNo;
      this.addDialogStatus = false;
      this.tripList[this.tripIndex].driver = "";
      this.tripList[this.tripIndex].status = { id: 4, status: "Driver Assigned" };
    },
    closeAssignDialog() {
      this.assignDialog = false;
      this.drivers = [...this.defaultDrivers];
      this.tripList[this.tripIndex].driver = "";
    },
    closeAddDialog() {
      this.addDialogStatus = false;
      this.drivers = [...this.defaultDrivers];
      this.tripList[this.tripIndex].driver = "";
    },
    closeVendorDialog() {
      this.dialogView = false;
      const index = this.tripList.findIndex((data) => data.driver === this.driverNumber);
      if (index !== -1) {
        this.tripList[index].driver = "";
      }
    },
    closeUnClubbingDialog() {
      this.unclubDialog = false;
      this.tripDetails = {};
    },

    checkUnAssign(data) {
      if (this.$isIndigo === "true" && data.employees.length > 1) {
        this.unclubDialog = true;
        this.tripDetails = data;
      } else {
        this.usAssignDriver(data);
      }
    },

    unclubTrip(crewIds) {
      this.usAssignDriver(this.tripDetails, crewIds);
    },
    async usAssignDriver(data, crewIds) {
      let confirmTitle = "Confirm Un-Assign";
      let confirmText = "Please confirm to Un-Assign this Driver";
      if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
        this.loading = true;
        try {
          const response = await axios.post("trip/unassign", { tripid: data.bigId, crewId: crewIds });
          if (response.status === 200) {
            this.reloadData();
            this.loading = false;
            if (crewIds) this.unclubDialog = false;
            const index = this.tripList.findIndex((trip) => trip.bigId === data.bigId);
            if (index !== -1) {
              this.tripList[index].driverDetails = null;
              this.tripList[index].status = { id: 2, status: "Approved" };
              this.$toasted.show(response.data.message, {
                position: "bottom-center",
                duration: 4000,
              });
              this.loading = false;
            }
          }
        } catch (error) {
          this.loading = false;
        }
      }
    },
    startTrip(data, index) {
      this.startDialog = true;
      this.statusBigId = data.bigId;
      if (data.status.id === 4 || data.status.id === 5 || data.status.id === 6) {
        this.status = "Start";
      }
    },
    closeDialog() {
      this.startDialog = false;
    },
    startEndTrip(data) {
      const index = this.tripList.findIndex((trip) => trip.bigId === data.id);
      if (index !== -1) {
        this.tripList.splice(index, 1);
      }
      this.startDialog = false;
    },
    getTripInfo(data) {
      this.remarksModel = !this.remarksModel;
      this.tripInfo.tripId = data.bigId;
      this.tripInfo.status = data.status.id;
    },
    async rejectTrip(remarks) {
      this.loading = true;
      try {
        let payload = {
          tripId: this.tripInfo.tripId,
          status: this.tripInfo.status,
          sp: localStorage.getItem("vendorName"),
          remarks: remarks,
        };
        const response = await axios.post("/trip/reject", payload);
        if (response.status === 200) {
          this.remarksModel = false;
          this.loading = false;
          this.$toasted.show(response.data, {
            position: "bottom-center",
            duration: 4000,
          });
          this.reloadData();
        } else {
          this.loading = false;
          this.$toasted.show(response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      } catch (error) {
        this.loading = false;
        this.$toasted.show(error.response.data, {
          position: "bottom-center",
          duration: 4000,
        });
      }
    },
    async approveTrip(trip) {
      let confirmTitle = "Confirm Approve";
      let confirmText = "Please confirm to approve this trip";
      if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
        this.loading = true;
        try {
          const payload = {
            tripid: trip.bigId,
          };
          const response = await axios.post("trip/approve", payload);
          this.loading = false;
          if (response.status === 200) {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
            this.reloadData();
          } else {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          }
        } catch (error) {
          this.loading = false;
          this.$toasted.show(error.response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      }
    },
    async approveCancel(trip) {
      let confirmTitle = "Approve Cancellation";
      let confirmText = "Please confirm your approval to cancel this trip";
      if (await this.$refs.confirm.open(confirmTitle, confirmText, {})) {
        this.loading = true;
        try {
          const payload = {
            tripid: trip.bigId,
          };
          const response = await axios.post("trip/approveCancel", payload);
          this.loading = false;
          if (response.status === 200) {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
            this.reloadData();
          } else {
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
          }
        } catch (error) {
          this.loading = false;
          this.$toasted.show(error.response.data, {
            position: "bottom-center",
            duration: 4000,
          });
        }
      }
    },
    async assignDriver(data) {
      let confirmTitle = "Confirm Assign";
      let confirmText = "Please confirm to Assign the driver";
      if (await this.$refs.confirm.open(confirmTitle, confirmText)) {
        this.loading = true;
        try {
          const payload = {
            driverId: this.driverDetails.token,
            vehicleId: this.vehicleData.token,
            vendorId: this.driverDetails.vendor,
            tripId: this.bigId,
            driverConfirm: data,
            employees: this.employees,
            pickUpdate: this.changedPickUpDate,
          };
          const response = await axios.post("/trip/assign", payload);
          if (response.status === 200) {
            this.loading = false;
            this.dialog = false;
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 4000,
            });
            this.cancelSubmit();
            const emitDetails = {
              name: this.driverDetails.name,
              number: this.driverNumber,
              vehicleNo: this.vehicleData.vehicleNo,
            };
            if (this.$isIndigo === "true") {
              this.checkClubbing();
            } else {
              this.$emit("assign-driver", emitDetails);
            }
          } else {
            this.loading = false;
            this.$toasted.show(response.data, {
              position: "bottom-center",
              duration: 6000,
            });
          }
        } catch (error) {
          this.loading = false;
        }
      }
    },

    async checkClubbing() {
      try {
        this.loading = true
        //    this.clubbingDialog = true;
        const payload = {
          tripId: this.tripDetails.bigId,
          driverToken: this.driverDetails.token,
          vehicleNo: this.vehicleData.vehicleNo,
          reportingTime: this.tripDetails.reportingTime,
          // pickupTime: this.employees.length > 0 ? this.employees[0].pickupTime : this.changedPickUpDate,
          pickupTime: this.employees.length > 0 && this.tripDetails.serviceType === 1 ? this.employees[0].pickupTime : this.changedPickUpDate,
          serviceType: this.tripDetails.serviceType,
          crewId: this.crewIds.length > 0 && this.crewIds[0],
        };


        const response = await axios.post("trip/toBeClubbed/list", payload);
     if (response.status === 200 && response.data.length > 0) {
    this.loading=false
    this.clubbingDialog = true;
    this.tripList = response.data;
   } else {
    this.cancelSubmit();
    const emitDetails = {
     name: this.driverDetails.name,
     number: this.driverNumber,
     vehicleNo: this.vehicleData.vehicleNo,
    };
    this.$emit("assign-driver", emitDetails);
   }
     } catch (error) {
    this.$toasted.show("Some error occured while checking for clubbing", {
      position: "bottom-center",
      duration: 4000,
      type: "error",
    });

     }
   finally {
    this.loading=false
   }
  },

  closeDVehicleDialog() {
   this.dialogView = false;
  },
  closeClubbing() {
   const emitDetails = {
    name: this.driverDetails.name,
    number: this.driverNumber,
    vehicleNo: this.vehicleData.vehicleNo,
   };
   this.$emit("assign-driver", emitDetails);
   this.clubbingDialog = false;
  },

  async acceptDriver() {
   await this.assignDriver();
  },
  closeDialog() {
   this.$emit("close-dialog");
  },
 },
};
</script>

<style scoped lang="scss">
@import "./driverAssign";

.update-block {
 .v-btn {
  color: white;
 }
}
</style>
